export const config =  {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '适用组织',
      dataIndex: 'orgName',
      width: 200,
    },
    {
      title: '适用列表',
      dataIndex: 'pageName',
      width: 160,
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 200,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      label: '适用组织',
      name: 'orgId',
      itemType: 'tree',
      data: 'company',
      labelKey: 'label',
      key: 'id',
      showSearch: true,
      width:300
    },
    {
      label: '适用列表',
      name: 'page',
      itemType: 'select',
      data: 'pageEnums',
      labelKey: 'description',
      width:300
    }
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd']
    }
  ]
}
